import lodash from 'lodash'
import React, { ReactElement, useEffect } from 'react'
import styled from 'styled-components'

import {
  AsyncValidationField,
  useField,
} from '../../../../../../../../../../1stlog-ui/src/components/Field'
import useFieldState from '../../../../../../../../../../1stlog-ui/src/components/Field/useFieldState'
import Input from '../../../../../../../../../../1stlog-ui/src/components/Input'
import { TOrderEntryReusableBoxInfo } from '../../../../../../../AdditionalServices/types'
import useOrderEntry from '../../../../../../../useOrderEntry'
import createValidateReusableBox from './validate'

const Wrapper = styled.div`
  // display: flex;
`

const ReusableBoxSearch = (): ReactElement => {
  const { reusableBoxUrl, currentCustomer } = useOrderEntry()

  const [identifier, setIdentifier] = useField('identifier', { asState: true })

  const [, setData] = useFieldState<TOrderEntryReusableBoxInfo | null>('data')

  const onClear = (): void => {
    setIdentifier('')
  }

  const onResult = (value: TOrderEntryReusableBoxInfo | null): void => {
    if (!value) {
      onClear()
    } else {
      setData(value)
    }
  }

  useEffect(() => {
    if (lodash.isEmpty(identifier)) {
      setData(null)
    }
  }, [identifier])

  // FIXME: https://github.com/final-form/react-final-form/issues/883
  return (
    <Wrapper>
      <AsyncValidationField
        name="identifier"
        validate={createValidateReusableBox(
          reusableBoxUrl,
          currentCustomer?.id,
          onResult,
        )}
      >
        <Input
          type="text"
          onClear={onClear}
          placeholder={i18n.t('reusable_box_search', 'Mehrwegbox suchen...')}
        />
      </AsyncValidationField>
    </Wrapper>
  )
}

export default ReusableBoxSearch
